<script>
    import { mapActions, mapState } from "vuex";
    import TheSkeleton from "@main/packages/TheSkeleton";
    import BaseAccordion from "@main/packages/BaseAccordion";
    import TypographyWrapper from "@/components/TypographyWrapper";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";
    import SchemaFaq from "@/components/SchemaFaq";

    export default {
        name: "GuaranteeContent",
        components: {
            SchemaFaq,
            BaseAccordion,
            TypographyWrapper,
            LinkWithAnalytics,
            TheSkeleton,
        },
        props: {
            email: {
                type: String,
                required: true,
            },
            emailAdditional: {
                type: String,
                default: "Напишите нам — ",
            },
            leftSideTitle: {
                type: String,
                default: "Гарантия и возврат",
            },
            rightSideTitle: {
                type: String,
                default: "Срок гарантии",
            },
            buttonVariant: {
                type: String,
                default: "v1",
            },
            buttonSize: {
                type: String,
                default: "md",
            },
        },
        data() {
            return {
                activeIndex: 0,
                isLoading: false,
            };
        },
        computed: {
            ...mapState("Root", {
                page: (state) => state.staticPage.guarantee,
            }),
            isNotSingleContentLeft() {
                return this.page.contentLeft?.length > 1;
            },
            contentLeftSingleText() {
                if (this.page.contentLeft) {
                    return this.page.contentLeft[0].desc;
                }
                return "";
            },
        },
        serverPrefetch() {
            return this.getStaticPage({ slug: "guarantee" });
        },
        mounted() {
            if (!this.page?.slug) {
                this.isLoading = true;
                this.getStaticPage({ slug: "guarantee" }).then(() => {
                    this.isLoading = false;
                });
            }
        },
        methods: {
            ...mapActions("Root", ["getStaticPage"]),
            changeIndex(index) {
                this.activeIndex = index;
            },
        },
    };
</script>

<template>
    <typography-wrapper>
        <div class="b-text-page">
            <the-skeleton v-if="isLoading" type="text-page"></the-skeleton>
            <template v-if="!isLoading && page">
                <div class="b-text-delivery">
                    <h2>{{ leftSideTitle }}</h2>

                    <div v-if="isNotSingleContentLeft" class="b-text-delivery__content">
                        <div class="b-text-delivery__accordion">
                            <base-accordion
                                v-for="(item, i) in page.contentLeft"
                                :key="i + 10"
                                :active-index="activeIndex"
                                :index="i"
                                :accordion="item"
                                custom-type
                                @change="changeIndex"
                            >
                            </base-accordion>
                        </div>
                    </div>

                    <div
                        v-else
                        class="b-text-delivery__text"
                        v-html="contentLeftSingleText"
                    ></div>
                </div>

                <div class="b-text-payment">
                    <h2>{{ rightSideTitle }}</h2>

                    <div class="b-text-payment__content" v-html="page.contentRight"></div>

                    <div class="b-text-payment__caption">Нужна помощь? <br />Жмите сюда</div>

                    <link-with-analytics
                        class="base-button b-text-payment__button"
                        :class="[`base-button--${buttonVariant} base-button--${buttonSize}`]"
                        type="email"
                        :text="email"
                    >
                        {{ emailAdditional }}{{ email }}
                    </link-with-analytics>
                </div>
            </template>

            <schema-faq :items="page.contentLeft"></schema-faq>
        </div>
    </typography-wrapper>
</template>

<style lang="scss">
    @import "~@/assets/sass/service-page.scss";
</style>
